import PropTypes from 'prop-types';
import React from 'react';

import { UserIcon } from '@heroicons/react/solid';
import noop from 'lodash/noop';

import Modal from 'components/Modal';
import Button from 'components/buttons/Button';

const CompanyMetaFoundersDeleteModal = ({
  open = true,
  name = '',
  onClose = noop,
  onDelete = noop,
}) => (
  <Modal open={open}>
    <Modal.Icon Icon={UserIcon} />
    <Modal.Title>Delete founder</Modal.Title>
    <Modal.Description>
      Are you sure you want to delete founder <b>{name}</b>
    </Modal.Description>
    <Modal.RightButtons>
      <Button type="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        onClick={onDelete}
        eventType="pressPage_update"
        eventProperties={{ action: 'founder_delete' }}
        data-test-id="company-meta-founders-deleteModal-delete"
      >
        Delete founder
      </Button>
    </Modal.RightButtons>
  </Modal>
);

CompanyMetaFoundersDeleteModal.propTypes = {
  open: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CompanyMetaFoundersDeleteModal;
